import React, { useState, Fragment, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'

import statement from '../../../images/Nav-Statement.svg'
import statementActive from '../../../images/Nav-Statement active.svg'
import students from '../../../images/Nav-Students.svg'
import studentsActive from '../../../images/Nav-Students active.svg'
import registration from '../../../images/Nav-Registration.svg'
import registrationActive from '../../../images/Nav-Registration active.svg'
import news from '../../../images/Nav-News.svg'
import newsActive from '../../../images/Nav-News active.svg'
import classes from './MainSidebar.module.css'

const SidebarNavParents = (props) => {
    const baseUrl = useSelector((state) => state.auth.url)
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null

    const [statementSrc, setStatementSrc] = useState(statement)
    const [studentsSrc, setStudentsSrc] = useState(students)
    const [registrationSrc, setRegistrationSrc] = useState(registration)
    const [newsSrc, setNewsSrc] = useState(news)
    const [hasNewsMedia, setHasNewsMedia] = useState(false)

    const showRegistrationRaw = typeof localStorage !== 'undefined' ? localStorage.getItem('ShowRegistration') : null
    const showRegistrationTab = showRegistrationRaw === 'true'

    useEffect(() => {
        let isMounted = true
        const controller = new AbortController()

        const fetchHasNews = async () => {
            if (!baseUrl || !token) {
                if (isMounted) setHasNewsMedia(false)
                return
            }
            try {
                const response = await fetch(`${baseUrl}api/registration-setup/media/has-any`, {
                    headers: { Authorization: `Bearer ${token}` },
                    signal: controller.signal,
                })
                if (!response.ok) {
                    if (isMounted) setHasNewsMedia(false)
                    return
                }
                const data = await response.json().catch(() => ({}))
                if (isMounted) setHasNewsMedia(!!data.hasMedia)
            } catch {
                if (isMounted) setHasNewsMedia(false)
            }
        }

        fetchHasNews()

        return () => {
            isMounted = false
            controller.abort()
        }
    }, [baseUrl, token])

    const statementHoverHandler = () => {
        setStatementSrc(statementActive)
    }

    const statementLeaveHandler = () => {
        setStatementSrc(statement)
    }

    const studentsHoverHandler = () => {
        setStudentsSrc(studentsActive)
    }

    const studentsLeaveHandler = () => {
        setStudentsSrc(students)
    }

    const registrationHoverHandler = () => {
        setRegistrationSrc(registrationActive)
    }

    const  registrationLeaveHandler = () => {
        setRegistrationSrc(registration)
    }

    const newsHoverHandler = () => {
        setNewsSrc(newsActive)
    }

    const newsLeaveHandler = () => {
        setNewsSrc(news)
    }



    const activeStatement = <Fragment><div><img src={statementActive} alt='' /></div><label>Billing</label></Fragment>
    const inActiveStatement = <Fragment><div><img src={statementSrc} alt='' /></div><label>Billing</label></Fragment>

    const activeStudents = <Fragment><div><img src={studentsActive} alt='' /></div><label>Students</label></Fragment>
    const inActiveStudents = <Fragment><div><img src={studentsSrc} alt='' /></div><label>Students</label></Fragment>

    const activeRegistration = <Fragment><div><img src={registrationActive} alt='' /></div><label>Registration</label></Fragment>
    const inActiveRegistration = <Fragment><div><img src={registrationSrc} alt='' /></div><label>Registration</label></Fragment>
    const activeNews = <Fragment><div><img src={newsActive} alt='' /></div><label>News</label></Fragment>
    const inActiveNews = <Fragment><div><img src={newsSrc} alt='' /></div><label>News</label></Fragment>

    return (
        <Fragment>
                <li className={classes['main-sidebar__item']} onMouseOver={statementHoverHandler} onMouseOut={statementLeaveHandler} onClick={() => props.onClose ? props.onClose() : {}}>
                    <NavLink to={`/parents/statement`}
                        className={(navData) => `${classes['main-sidebar__nav']} ${navData.isActive ? classes.active : ''}`}
                        children={(navData) => navData.isActive ? activeStatement : inActiveStatement}
                    />
                </li>
                <li className={classes['main-sidebar__item']} onMouseOver={studentsHoverHandler} onMouseOut={studentsLeaveHandler} onClick={() => props.onClose ? props.onClose() : {}}>
                    <NavLink to={`/parents/students`}
                        className={(navData) => `${classes['main-sidebar__nav']} ${navData.isActive ? classes.active : ''}`}
                        children={(navData) => navData.isActive ? activeStudents : inActiveStudents}
                    />
                </li>
                {showRegistrationTab && <li className={classes['main-sidebar__item']} onMouseOver={registrationHoverHandler} onMouseOut={registrationLeaveHandler} onClick={() => props.onClose ? props.onClose() : {}}>
                    <NavLink to={`/parents/registration`}
                        className={(navData) => `${classes['main-sidebar__nav']} ${navData.isActive ? classes.active : ''}`}
                        children={(navData) => navData.isActive ? activeRegistration : inActiveRegistration}
                    />
                </li>}
                {hasNewsMedia && <li className={classes['main-sidebar__item']} onMouseOver={newsHoverHandler} onMouseOut={newsLeaveHandler} onClick={() => props.onClose ? props.onClose() : {}}>
                    <NavLink to={`/parents/news`}
                        className={(navData) => `${classes['main-sidebar__nav']} ${navData.isActive ? classes.active : ''}`}
                        children={(navData) => navData.isActive ? activeNews : inActiveNews}
                    />
                </li>}
        </Fragment>
    )
}

export default SidebarNavParents